export const themeLocale: Record<string, string> = {
  base: "theme.base",
  fairy_tale: "theme.fairyTale",
  flower_garden: "theme.flowerGarden",
  hacienda: "theme.hacienda",
  magical_night: "theme.magicalNight",
  tropical: "theme.tropical",
};
